
import { defineComponent, onMounted } from "vue";
import TrainerWithCourse from "@/views/Pending/list/TrainerWithCourse.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "dashboard",
  components: {
    TrainerWithCourse,
  },
  data() {
    return {
      data: "",
    };
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
  },
});
